import { Toast } from 'vant'
/**
 * 密码格式验证
 * @param rule 验证规则（不少于6位）
 * @param value 需要验证的值
 * @param callback 回调函数
 */
export const validatePassword = (value) => {
    // let pas =  /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,13}$/
    // if(!pas.test(value)){
    //   Toast('密码至少包含大写字母，小写字母，数字，且不少于8位');
    // }else {
    // }
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,13}$/.test(value);
  };
  export const validatePassword1 = (value) => {
    return /[a-zA-Z0-9]{6,}/.test(value);
  };
  /**
   * 手机号码格式验证
   * @param rule 验证规则
   * @param value 需要验证的值
   * @param callback 回调函数
   */
  // export const validateMobile = (rule, value, callback) => {
  export const validateMobile = (value) => {
    // const reg =  /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    // if (!reg.test(value)) {
    //   Toast('请输入正确格式的手机号码');
    // } else {
    // }
    return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value);
  };

  /**
   * 身份证号码格式验证
   * @param rule 验证规则（是否满足18位）
   * @param value 需要验证的值
   * @param callback 回调函数
   */
  export const validateIDCard = (rule, value, callback) => {
    const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (!reg.test(value)) {
      callback(new Error('身份证号码格式错误'));
    } else {
      callback();
    }
  };

  //处理后端返回未分割的字符串。以英文(为截取点，再拼接(
export const dealStr = (str)=>{
  if(!str){
    return ""
  }
  let arr = [];
  const arrBefore = str.split("(");
  if(arrBefore) {
    for (let i = 0;i<arrBefore.length;i++){
      const item = arrBefore[i];
      if(item!=""){
        arr.push("("+item);
      }
    }
  }
 
  return arr
}


